import React from 'react';
import { Mail, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#013139] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_negocio-rapido-2/artifacts/pdnfkao1_LOGO%20MONOCROMA%20CLARO.png"
              alt="FluenceIA"
              className="h-12 w-auto mb-4 !shadow-lg" />

            <p className="text-gray-300 leading-relaxed max-w-md">
              Consultoría de automatización con IA para pequeños negocios, autónomos y despachos profesionales. 
              Hacemos tu negocio más eficiente sin complicaciones.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#00E5A3]">Navegación</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('inicio')}
                  className="text-gray-300 hover:text-[#00E5A3] transition-colors">

                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicios')}
                  className="text-gray-300 hover:text-[#00E5A3] transition-colors">

                  Servicios
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('sobre-mi')}
                  className="text-gray-300 hover:text-[#00E5A3] transition-colors">

                  Sobre mí
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="text-gray-300 hover:text-[#00E5A3] transition-colors">

                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#00E5A3]">Contacto</h3>
            <div className="space-y-3">
              <a
                href="mailto:esaezye@gmail.com"
                className="flex items-center gap-2 text-gray-300 hover:text-[#00E5A3] transition-colors">

                <Mail size={18} />
                <span>esaezye@gmail.com</span>
              </a>
              <a
                href="https://www.linkedin.com/in/emilio-s%C3%A1ez-yebra-1b65b8164/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-300 hover:text-[#00E5A3] transition-colors">

                <Linkedin size={18} />
                <span>LinkedIn</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} FluenceIA - Emilio Sáez Yebra. Todos los derechos reservados.
            </p>
            <div className="flex gap-6 text-sm">
              <button className="text-gray-400 hover:text-[#00E5A3] transition-colors">
                Política de Privacidad
              </button>
              <button className="text-gray-400 hover:text-[#00E5A3] transition-colors">
                Aviso Legal
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;